import {
    Box,
    CircularProgress,
    IconButton,
    Stack,
    Tooltip,
} from '@mui/material';
import { Link } from 'react-router-dom';

import { SVGAsset } from 'components/atoms/SVGAsset';
import { Typography } from 'components/atoms/Typography';
import { useSignOut } from 'hooks/api/auth/useSignOut';
import { useUser } from 'hooks/api/auth/useUser';

import { AccSettings } from './AccSettings';
import { HeaderWrapper } from './Header.styled';

export const Header = (): JSX.Element => {
    const { user } = useUser();

    const { signOut, loading } = useSignOut();

    return (
        <HeaderWrapper>
            <Link to="/">
                <Typography variant="title.medium">
                    ГОСУДАРСТВЕННЫЙ ДОКЛАД • 2021
                </Typography>
            </Link>
            <Stack
                spacing={0.5}
                direction="row"
                alignItems="center"
                sx={{ ml: 'auto' }}
            >
                <Typography variant="title.medium">{user?.email}</Typography>
                <AccSettings />
                <Tooltip
                    title="Выйти из аккаунта"
                    arrow
                    placement="bottom-end"
                    enterDelay={1000}
                >
                    <Box>
                        <IconButton
                            color="inherit"
                            onClick={() => signOut()}
                            edge="end"
                            size="small"
                        >
                            {loading ? (
                                <CircularProgress
                                    variant="indeterminate"
                                    size={20}
                                    color="inherit"
                                />
                            ) : (
                                <SVGAsset src="icons.24px.logout" />
                            )}
                        </IconButton>
                    </Box>
                </Tooltip>
            </Stack>
        </HeaderWrapper>
    );
};
